export enum AppAlertType {
  empty,
  sweetError,
  sweetQuestion,
  sweetSuccess,
  sweetInfo,
  sweetWarning,
  sweetConfirm, // icon: warning
  sweetMessage, // no icon // with or without message text
  sweetImageMessage,
  sweetInput,
  sweetAutoClose,
}

export class AppAlert {
  public static empty = new AppAlert('', AppAlertType.empty);
  public header?: string;
  public message: string;
  public alertType: AppAlertType;
  public acceptLabel?: string;
  public rejectLabel?: string;
  public image?: string;
  public accept?: () => void;
  public reject?: () => void;
  public time?: number;

  constructor(alertMessage: string, alertType: AppAlertType, time?: number) {
    this.message = alertMessage;
    this.alertType = alertType;
    this.time = time;
  }
}
